// Angular
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

// Afidium
import { IRemark } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { TravellerDataTranslationService } from 'libraries/service/traveller-data-translation/traveller-data-translation.service';
import { IMomentDateFormat } from "libraries/interfaces/IMomentDateFormat";

@Component({
    selector: 'remark',
    template: `
        <div class="container">
            <div class="col-left">
                <span *ngIf="remark.whenLastUpdated">
                    {{ remark.whenLastUpdated | dateMoment: dateFormat.momentMedium }}
                </span>

                <strong>{{ role }}</strong>
            </div>

            <div class="col-right">
                <div *ngFor="let text of remark.text">
                    {{ text }}
                </div>
            </div>
        </div>
    `,
    styleUrls: ['../shared/remark.scss']
})
export class RemarksComponent implements OnChanges {
    @Input()
    public remark: IRemark;

    public dateFormat: IMomentDateFormat = JSON.parse(sessionStorage.getItem('dateFormat'));

    public role: string;

    constructor(
        private readonly travellerDataTranslationService: TravellerDataTranslationService
    ) {}

    public ngOnChanges(simpleChanges: SimpleChanges): void {
        if (simpleChanges.remark.currentValue !== simpleChanges.remark.previousValue) {
            this.role = this.travellerDataTranslationService.translateRole(this.remark.scope);
        }
    }
}